"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _modal = _interopRequireDefault(require("./modal"));

var _kambriaUtil = require("@kambria/kambria-util");

var _bind = _interopRequireDefault(require("classnames/bind"));

var _indexModule = _interopRequireDefault(require("../static/styles/index.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind.default.bind(_indexModule.default);

const DEFAULT_STATE = {
  data: []
};

class GetApproval extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "formalizeTxParams", txParams => {
      if (!txParams) return this.setState(_objectSpread({}, DEFAULT_STATE));
      let data = [];
      let from = txParams.from;
      let to = '';
      let coin = 'ETH';
      let amount = txParams.value ? _kambriaUtil.unit.wei2ETH(txParams.value) : 0;
      let tokens = [];
      if (!txParams.data) to = txParams.to;else {
        let raw = _kambriaUtil.net.parseKambriaTransaction(txParams);

        if (raw) {
          to = raw.to;
          tokens = [{
            token: 'KAT',
            amount: _kambriaUtil.unit.wkat2KAT(raw.amount)
          }];
        }
      }
      data.push({
        from,
        to,
        coin,
        amount,
        tokens
      });
      return this.setState({
        data: data
      });
    });

    _defineProperty(this, "onClose", () => {
      this.setState({
        visible: false,
        txParams: null
      }, () => {
        this.props.done(null, false);
      });
    });

    _defineProperty(this, "onApprove", () => {
      this.setState({
        visible: false,
        txParams: null
      }, () => {
        this.props.done(null, true);
      });
    });

    _defineProperty(this, "renderSingleTx", tx => {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: Math.random().toString(),
        className: cx("tab-content", "mb-4")
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: cx("form-group")
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "from"
      }, "Source Address"), /*#__PURE__*/_react.default.createElement("input", {
        className: cx("form-control"),
        type: "text",
        value: tx.from,
        disabled: true
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: cx("form-group")
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "from"
      }, "Destination Address"), /*#__PURE__*/_react.default.createElement("input", {
        className: cx("form-control"),
        type: "text",
        value: tx.to,
        disabled: true
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: cx("form-group")
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "from"
      }, "Amount of ", tx.coin), /*#__PURE__*/_react.default.createElement("input", {
        className: cx("form-control"),
        type: "text",
        value: tx.amount,
        disabled: true
      })), tx.tokens.map(item => /*#__PURE__*/_react.default.createElement("div", {
        key: item.token,
        className: cx("form-group")
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "from"
      }, "Amount of ", item.token), /*#__PURE__*/_react.default.createElement("input", {
        className: cx("form-control"),
        type: "text",
        value: item.amount,
        disabled: true
      }))));
    });

    _defineProperty(this, "renderMultiTxs", () => {
      let data = this.state.data;
      if (!data || data.length <= 0) return null;
      let visual = [];

      var _iterator = _createForOfIteratorHelper(data),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          let tx = _step.value;
          visual.push(this.renderSingleTx(tx));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return visual;
    });

    this.state = {
      visible: props.visible,
      txParams: props.txParams
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      this.setState({
        visible: this.props.visible
      });
    }

    if (this.props.txParams !== prevProps.txParams) {
      this.formalizeTxParams(this.props.txParams);
    }
  }

  render() {
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      visible: this.state.visible,
      className: cx("fade", "wallet-modal", "software-wallet"),
      dialogClassName: cx("modal-dialog-centered")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: cx("modal-body")
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: cx("close-button"),
      onClick: this.onClose
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: cx("title", "d-block", "text-center", "mt-4")
    }, "Transaction Approval"), this.renderMultiTxs(), /*#__PURE__*/_react.default.createElement("div", {
      className: cx("form-inline")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: cx("form-group", "ml-auto")
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: cx("btn", "btn-sm", "btn-primary-gray", "ml-1", "text-center"),
      onClick: this.onClose
    }, "Cancel"), /*#__PURE__*/_react.default.createElement("button", {
      className: cx("btn", "btn-sm", "btn-primary", "ml-1", "text-center"),
      onClick: this.onApprove
    }, "OK")))));
  }

}

var _default = GetApproval;
exports.default = _default;